import styles from './ChevronLeft.module.scss';
import classNames from 'classnames/bind';

let cx = classNames.bind(styles);

export function ChevronLeft({className}) {
  const classNameArray = className?.split(' ') || [];
	return (
		<svg width="100%" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={cx(['chevron-left-icon', ...classNameArray])} aria-hidden="true">
			<path d="M7.873 1.5 1.373 8l6.5 6.5" stroke="#202020" strokeWidth="2.34" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
}
